module.exports = __webpack_public_path__ + "static/media/Info-green.c48681d4.svg";